var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAddIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "add_icon",
    d: "M18.111 10.111h-6.222V3.889a.889.889 0 1 0-1.778 0v6.222H3.889a.889.889 0 1 0 0 1.778h6.222v6.222a.889.889 0 0 0 1.778 0v-6.222h6.222a.889.889 0 0 0 0-1.778z",
    "data-name": "add icon",
    transform: "translate(-3 -3)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAddIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/add-icon.c8a5a67a.svg";
export { ForwardRef as ReactComponent };